import type { NonBusinessDay } from '@/types/model.types';

const MINS_IN_HOUR = 60;
const MARKET_OPEN_MINS = 9 * MINS_IN_HOUR + 30;
const MARKET_CLOSE_MINS = 16 * MINS_IN_HOUR;

/**
 * Lifted out of home.page.ts. Pure, so it can be tested without a component
 * and without waiting for a particular time of day.
 */
export function getMarketClose(
  now: Date,
  nonBusinessDays: Record<string, NonBusinessDay>,
): string {
  // Reinterpret the instant in New York, which is what the market runs on.
  const nyTimestamp = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));

  if ([0, 6].includes(nyTimestamp.getDay())) return 'Closed';

  const year = nyTimestamp.getFullYear();
  const month = String(nyTimestamp.getMonth() + 1).padStart(2, '0');
  const day = String(nyTimestamp.getDate()).padStart(2, '0');
  const holiday = nonBusinessDays[`${year}-${month}-${day}`];
  if (holiday) return `Closed for ${holiday.description}`;

  const currentMins = nyTimestamp.getHours() * MINS_IN_HOUR + nyTimestamp.getMinutes();
  if (currentMins < MARKET_OPEN_MINS || currentMins >= MARKET_CLOSE_MINS) return 'Closed';

  const remainingHours = Math.floor((MARKET_CLOSE_MINS - currentMins) / MINS_IN_HOUR);
  const remainingMins = MINS_IN_HOUR - (currentMins % MINS_IN_HOUR);
  return `${remainingHours} hours ${remainingMins} minutes`;
}
